import { Currency } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

const AdmissionForm = () => {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
        setValue
    } = useForm();
    const urlmain = process.env.REACT_APP_API_URL
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
    const navigatenext = JSON.parse(localStorage.getItem("checkout_data")) || ""
    const navigate = useNavigate();
    const [isEdit, setIsEdit] = useState(false);
    const [admissionId, setAdmissionId] = useState(null);

    const fetchDataSingle = async () => {
        try {
            const response = await fetch(`${urlmain}/admission/single/${userData?.user_id}`);
            const res = await response.json();

            if (res.user) {
                setIsEdit(true);
                setAdmissionId(res.user.id); // keep admission id for PUT

                // ✅ Prefill form fields
                Object.keys(res.user).forEach((key) => {
                    if (res.user[key] !== null && res.user[key] !== undefined) {
                        setValue(key, res.user[key]);
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    };


    const onSubmit = async (data) => {
        if (!/^[0-9]{12}$/.test(data.aadhar)) {
            toast.error("Aadhar must be exactly 12 digits (numbers only)");
            return;
        }

        if (!data.rulesAgreed) {
            toast.error("You must agree to the Rules & Regulations.");
            return;
        }

        const payload = {
            ...data,
            user_id: userData?.user_id,
            user_name: userData?.full_name,
            main_id: process.env.REACT_APP_PERFUME_ID
        };
        const endpoint = isEdit
            ? `${urlmain}/admission/${admissionId}`
            : `${urlmain}/admission`;

        const method = isEdit ? "PUT" : "POST";
        try {
            const response = await fetch(`${endpoint}`, {
                method: method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const res = await response.json();
            if (response.ok) {
                console.log(res.data);
                localStorage.setItem("admission", JSON.stringify(res.data));
                // await placeOrder(res.payment_id);
                if (navigatenext) {
                    navigate("/checkout")
                } else {
                    navigate("/admission-form-step-2")
                }
                toast.success("Admission form submitted successfully!");
                reset();
            }
        } catch (error) {
            toast.error("Submission failed. Please try again.");
            console.error(error);
        }
    };



    const placeOrder = async (payment_id) => {
        const payload = {
            amount: 1000,
            order_id: payment_id,
            user_id: userData?.user_id,
            user_name: userData?.full_name,
            main_id: process.env.REACT_APP_PERFUME_ID
        }
        try {
            const response = await fetch(`${urlmain}/feepay`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            })
            const result = await response.json();
            if (result.success) {
                // openRazorpay(result.razorpay_order, result.order_id);


            } else {
                toast.error("Failed to create Razorpay Order")
            }
        } catch (error) {
            console.error(error)
        }
    }

    const openRazorpay = (razorpayOrder, order_id) => {
        const options = {
            key: "rzp_test_zEWr4dOpfx4w2F",
            amount: razorpayOrder.amount,
            currency: razorpayOrder.currency,
            name: "Forever Skates",
            description: "Order Payment",
            order_id: razorpayOrder.id,
            handler: async function (response) {
                const verifyRes = await fetch(`${urlmain}/feepay/verify`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                    })
                })
                const verifyData = await verifyRes.json();
                if (verifyData.success) {
                    window.location.href = `/payment-successad/${order_id}`; // ✅ Redirect on success
                } else {
                    window.location.href = `/payment-failedad/${order_id}`; // ❌ Redirect on failure
                }
            },
            prefill: {
                name: userData?.full_name,
                email: userData?.email
            },
            theme: { color: "#2a9d8f" }
        }
        const rzp = new window.Razorpay(options)
        rzp.open();
    }


    useEffect(() => {
        fetchDataSingle();
    }, [])


    return (
        <>
            <ToastContainer position="top-center" />

            <div className="inquiry-form-container">
                <h2>Admission Form</h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="inquiry-form-step">

                        {/* Full Name */}
                        <div className="inquiry-input-group">
                            <label>Full Name</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-user inquiry-input-icon"></i>
                                <input {...register("name", { required: true })} placeholder="Enter full name" />
                            </div>
                            {errors.name && <span className="mobile-error">This field is required</span>}
                        </div>

                        {/* Father Name */}
                        <div className="inquiry-input-group">
                            <label>Father Name</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-user inquiry-input-icon"></i>
                                <input {...register("fatherName", { required: true })} placeholder="Enter father name" />
                            </div>
                            {errors.fatherName && <span className="mobile-error">This field is required</span>}
                        </div>

                        {/* Mother Name */}
                        <div className="inquiry-input-group">
                            <label>Mother Name</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-user inquiry-input-icon"></i>
                                <input {...register("motherName", { required: true })} placeholder="Enter mother name" />
                            </div>
                            {errors.motherName && <span className="mobile-error">This field is required</span>}
                        </div>

                        {/* DOB */}
                        <div className="inquiry-input-group">
                            <label>Date of Birth</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-calendar inquiry-input-icon"></i>
                                <input type="date" {...register("dob")} />
                            </div>
                        </div>

                        {/* Aadhar */}
                        <div className="inquiry-input-group">
                            <label>Aadhar Number</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-id-card inquiry-input-icon"></i>
                                <input
                                    type="text"  // keep as text so maxlength works
                                    inputMode="numeric" // mobile keyboards show numbers
                                    {...register("aadhar", {
                                        required: "Aadhar number is required",
                                        pattern: {
                                            value: /^[0-9]{12}$/,  // only 12 digits allowed
                                            message: "Aadhar must be exactly 12 digits",
                                        },
                                    })}
                                    placeholder="Enter Aadhar Number"
                                    maxLength={12}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/\D/g, ""); // remove non-numbers
                                    }}
                                />
                            </div>
                            {errors.aadhar && (
                                <span className="mobile-error">{errors.aadhar.message}</span>
                            )}
                        </div>



                        {/* Gender */}
                        <div className="inquiry-input-group">
                            <label>Gender</label>
                            <div className="inquiry-radio-wrapper">
                                {["Male", "Female", "Other"].map((gender) => (
                                    <label key={gender}>
                                        <input
                                            type="radio"
                                            value={gender}
                                            {...register("gender", { required: true })}
                                        />
                                        {gender}
                                    </label>
                                ))}
                            </div>
                            {errors.gender && <span className="mobile-error">This field is required</span>}
                        </div>

                        {/* School Name */}
                        <div className="inquiry-input-group">
                            <label>School Name</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-building inquiry-input-icon"></i>
                                <input {...register("school")} placeholder="Enter school name" />
                            </div>
                        </div>

                        {/* Address */}
                        <div className="inquiry-input-group">
                            <label>Address</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-map-marker inquiry-input-icon"></i>
                                <input {...register("address", { required: true })} placeholder="Enter address" />
                            </div>
                            {errors.address && <span className="mobile-error">This field is required</span>}
                        </div>

                        {/* Pincode */}
                        <div className="inquiry-input-group">
                            <label>Pincode</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-map-pin inquiry-input-icon"></i>
                                <input {...register("pincode", { required: true })} placeholder="Enter pincode" />
                            </div>
                            {errors.pincode && <span className="mobile-error">This field is required</span>}
                        </div>

                        {/* Contact Number */}
                        <div className="inquiry-input-group">
                            <label>Contact Number</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-phone inquiry-input-icon"></i>
                                <input {...register("mobile", { required: true })} placeholder="Enter contact number" />
                            </div>
                            {errors.mobile && <span className="mobile-error">This field is required</span>}
                        </div>

                        {/* Email */}
                        <div className="inquiry-input-group">
                            <label>Email ID</label>
                            <div className="inquiry-input-wrapper">
                                <i className="fa fa-envelope inquiry-input-icon"></i>
                                <input type="email" {...register("email", { required: true })} placeholder="Enter email" />
                            </div>
                            {errors.email && <span className="mobile-error">This field is required</span>}
                        </div>

                        {/* Center Radio */}
                        <div className="inquiry-input-group">
                            <label>Select Center</label>
                            <div className="inquiry-radio-wrapper">
                                {["Malad (E)", "Goregoan (W)", "Malad (W)", "Andheri"].map((center) => (
                                    <label key={center}>
                                        <input type="radio" value={center} {...register("center", { required: true })} />
                                        {center}
                                    </label>
                                ))}
                            </div>
                            {errors.center && <span className="mobile-error">This field is required</span>}
                        </div>
                    </div>
                    {/* Rules */}
                    <div className="inquiry-input-group">
                        <label>Rules & Regulations</label>
                        <div className="inquiry-input-wrapper">
                            <textarea
                                className="inquiry-form-textarea"
                                rows="6"
                                readOnly
                                value={`Fees must be paid in advance along with the admission form (on or before the 10th of the respective month). A late fine of INR 200 will be applicable for delayed payments — no exceptions. This amount will be used to support underprivileged children who lack access to basic sports essentials.

All fees are strictly non-refundable, regardless of student absence or session cancellation due to public holidays or unforeseen events.

Wearing Guard Set, Helmet, and Club Bodysuit is mandatory for all students.

Parental interference during sessions is not permitted.

Parents are not allowed to enter the skating area during ongoing sessions.

NOTE: Parents are responsible for ensuring their child's safety before and after sessions. Radical Sports Academy will not be held liable for any injuries or incidents during training.`}
                            />

                        </div>

                        <label className='form-agree'>
                            <input type="checkbox" {...register("rulesAgreed", { required: true })} />
                            I agree to the Rules & Regulations
                        </label>
                        {errors.rulesAgreed && <span className="mobile-error">You must agree to proceed</span>}
                    </div>
                    <button type="submit" className="inquiry-submit-btn" disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Submit Admission Form"}
                    </button>
                </form>
            </div>

        </>
    );
};

export default AdmissionForm;
